import { createDatabase } from './CreateDatabase'; // Import the createDatabase function

// Insert or update faculties data in IndexedDB
const insertFacultyToDB = async (faculties) => {
  const db = await createDatabase(); // Ensure the database is set up

  const tx = db.transaction('faculties', 'readwrite');
  const store = tx.objectStore('faculties');

  try {
      // Insert each faculty and log confirmation
      for (const faculty of faculties) {
        //   console.log("Inserting faculty into IndexedDB:", faculty); // Log each faculty
          await store.put(faculty); // Use `put` to add or update faculty entries
      }

      await tx.done; // Ensure transaction completion
    //   console.log("All faculties inserted/updated successfully.");
  } catch (error) {
      console.error('Error inserting or updating faculties:', error);
      throw error;
  }
};

// Retrieve all faculties from IndexedDB, filtered by universityID, and sort by name
const getFacultiesFromDB = async (universityID) => {
   /*  if (!universityID) {
        console.error("Invalid universityID provided:", universityID);
        throw new Error("Invalid universityID for IndexedDB query.");
    } */

    if(Number(universityID) > 0 ) {
    const db = await createDatabase(); // Ensure the database is set up
    const tx = db.transaction('faculties', 'readonly');
    const store = tx.objectStore('faculties');
    const universityIDIndex = store.index('universityIDIndex'); // Assuming an index exists on universityID

    const range = IDBKeyRange.only(universityID); // Set up the key range
    const faculties = [];

    try {
        let cursor = await universityIDIndex.openCursor(range); // Open cursor with the universityID range


        // Traverse through the cursor to collect faculties
        while (cursor) {
            faculties.push(cursor.value);
            cursor = await cursor.continue();
        }

        await tx.done; // Ensure transaction completion
        faculties.sort((a, b) => a.name.localeCompare(b.name)); // Sort by name

       //  console.log("Retrieved faculties from IndexedDB:", faculties);
        return faculties;
    } catch (error) {
        console.error("An error occurred while retrieving faculties:", error);
        throw error;
    }
}
};

// Count all faculties in IndexedDB
const countFacultiesFromDB = async () => {
    const db = await createDatabase(); // Ensure the database is set up

    const tx = db.transaction('faculties', 'readonly');
    const store = tx.objectStore('faculties');

    try {
        const count = await store.count(); // Count records in the object store
        await tx.done; // Ensure transaction completion
      //   console.log("Count of faculties in IndexedDB:", count);
        return count;
    } catch (error) {
        console.error('Error counting faculties:', error);
        throw error;
    }
};

// Fetch both faculties and the count of faculties in parallel
const fetchFacultiesAndCount = async (universityID) => {
    try {

        await insertFacultyToDB(universityID); // Ensure faculties are inserted first

         const [faculties, count] = await Promise.all([
            getFacultiesFromDB(universityID), // Retrieves sorted faculties by universityID
            countFacultiesFromDB() // Retrieves the total count
            
        ]); 

      //   console.log("Faculties fetched from IndexedDB:", faculties);
       //  console.log("Total count of faculties:", count);

        return { faculties, count };
    } catch (error) {
        console.error('Error fetching faculties and count:', error);
        throw error;
    }
};

export { insertFacultyToDB, getFacultiesFromDB, countFacultiesFromDB, fetchFacultiesAndCount };